module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAARCAYAAADkIz3lAAAAAXNSR0IArs4c6QAAAERJREFUKBVj+P//vzIQN4NoBkIAqMgeiN+AaEJqGUYVIwcRMDSsgHgrshgGm6ggG9aKWIC+A6VDFyA2Z2RkvIsRRlABAMaFpndwIXZpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 1